export default {
  env: "prod",
  mcpUrl: "https://mcp.crossbeam.com",
} as const;
